import axios from 'axios'

export interface LoginRequest {
  username: string
  password: string
  tenantId?: string
}

export interface LoginResponse {
  token: string
  /** Порог продления сессии, сек (SESSRENEW O5); нет — старый сервер, фолбэк UI 1 ч. */
  renewAfterSec?: number
}

/** Единственный HTTP-запрос — получение JWT до подключения к NATS */
export const login = async (data: LoginRequest): Promise<LoginResponse> => {
  const resp = await axios.post<LoginResponse>('/api/v1/auth/login', data)
  return resp.data
}

/** Подсказка не должна держать страницу входа: не ответил за 3 с — вход с ручным полем. */
const TENANT_HINT_TIMEOUT_MS = 3_000

/**
 * Тенант по хосту страницы входа — свои веб-домены тенанта (CUSTDOM). Сервер отвечает один id
 * или `null`; списка тенантов до входа нет. REST: до входа шины у браузера ещё нет.
 */
export const fetchTenantHint = async (host: string): Promise<string | null> => {
  const resp = await axios.get<{ tenantId: string | null }>('/api/v1/auth/tenant-hint', {
    params: { host },
    timeout: TENANT_HINT_TIMEOUT_MS,
  })
  return resp.data.tenantId
}
